import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  private http = inject(HttpClient);
  private apiBaseUrl = environment.apiBaseUrl;

  exportCdfiProfiles(type: 'json' | 'csv'): Observable<Blob> {
    return this.http.get(`${this.apiBaseUrl}/api/admin/export/cdfis`, {
      params: { type },
      responseType: 'blob',
    });
  }
}
